import { getTextFromRect } from '@deskfy/deskfy-svg'

;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .factory('FontFamilyDropdownService', fontFamilyDropdownService)

  /* @ngInject */
  function fontFamilyDropdownService ($cookies, $translate, $compile, $rootScope, Utils, CONSTANTS, SvgToolboxCustomerFontService) {
    const fontsCache = {
      custom: [],
      default: []
    }

    const service = {
      initializeDropdown,
      onFontClick,
      addDefaultFontsToList,
      addCustomFontsToList,
      addFontToMenu,
      addArtsFontsToList,
      resetFontDropdown
    }

    return service

    function initializeDropdown (onFontFamilySearchResponse) {
      setTimeout(function () {
        if ($('.fonts-menu-tab.customFonts').hasClass('selected') || $('.toolbox-menu-list.custom').hasClass('selected')) {
          $('.font-family-dropdown').dropdown({
            apiSettings: {
              url: Utils.fnAddQueryToUrl(CONSTANTS.URL_FONTS_SEARCH, { search: '{query}', jwt: $cookies.get('jwt') }),
              onResponse: onFontFamilySearchResponse,
              cache: false
            },
            selectOnKeydown: false,
            message: {
              noResults: $translate.instant('noFontsFound')
            }
          })
        } else {
          $('.font-family-dropdown').dropdown({
            selectOnKeydown: false,
            message: {
              noResults: $translate.instant('noFontsFound')
            }
          })
        }
      }, 100)
    }

    function onFontClick (text, rect, font, svgEditorInstance) {
      return function () {
        svgEditorInstance.saveState()
        const fontFamily = font.fontFamily
        text.attr('font-family', fontFamily)
        text.node.style.fontWeight = ''
        text.node.style.fontStyle = 'normal'
        svgEditorInstance.resizeRectToText(text, rect, true, true)
      }
    }

    function manipulateFontsAndCache (tab, target, svgEditorInstance, fonts) {
      const fragment = document.createDocumentFragment()
      const isCacheFilled = Object.keys(fonts).length === fontsCache[tab].length
      if (isCacheFilled) {
        fontsCache[tab].forEach(({ menuItem, font }) => {
          registerFontClick(menuItem, svgEditorInstance, font)
          fragment.appendChild(menuItem[0])
        })
        target.append(fragment)
      } else {
        fontsCache[tab] = []
        for (const keyFont in fonts) {
          const fontElement = addFontToMenu(fonts[keyFont], null, svgEditorInstance)
          fragment.appendChild(fontElement.menuItem[0])
          fontsCache[tab].push(fontElement)
        }
        target.append(fragment)
      }
    }

    function addDefaultFontsToList (fontFamilyListDefault, svgEditorInstance) {
      manipulateFontsAndCache('default', fontFamilyListDefault, svgEditorInstance, SvgToolboxCustomerFontService.oFonts)
    }

    function addCustomFontsToList (fontFamilyListCustom, svgEditorInstance, toolboxOptionsInstance) {
      manipulateFontsAndCache('custom', fontFamilyListCustom, svgEditorInstance, SvgToolboxCustomerFontService.oCustomFonts)

      addArtsFontsToList(fontFamilyListCustom, svgEditorInstance, toolboxOptionsInstance)

      const arrayElements = svgEditorInstance.getElementsSelected()

      for (const text of arrayElements) {
        const font = toolboxOptionsInstance.getFontObjectByFamilyName(text.attr('font-family'))
        if (font) {
          $('.item.toolboxEditor.' + font.className).addClass('active')
          $('.item.toolboxEditor.' + font.className).addClass('selected')
        }
      }
    }

    function registerFontClick (menuItem, svgEditorInstance, font) {
      const arrayElements = svgEditorInstance.getElementsSelected()

      for (const rect of arrayElements) {
        const text = getTextFromRect(rect.node).instance
        if ($rootScope.isUser() && text.hasClass('fontFamily-edition-blocked')) {
          continue
        }
        menuItem.on('click', onFontClick(text, rect, font, svgEditorInstance))
      }
    }

    function addFontToMenu (font, target, svgEditorInstance) {
      const menuItem = $(`<div class='item toolboxEditor ${font.className}' data-value='${font.className}' style='font-family: ${font.className}'>${font.displayName}<uds-icon name="check" size="small" id='icon_${font.className}'/></div>`)
      registerFontClick(menuItem, svgEditorInstance, font)

      if (target) {
        target.append(menuItem)
      }

      return { font, menuItem }
    }

    function addArtsFontsToList (fontFamilyListCustom, svgEditorInstance, toolboxOptionsInstance) {
      if (svgEditorInstance.$scope && svgEditorInstance.$scope.artFonts) {
        toolboxOptionsInstance.artsFonts = []
        svgEditorInstance.$scope.artFonts.forEach(artFont => {
          artFont = {
            displayName: artFont.name.replace(/\.(ttf|otf)$/i, ''),
            className: artFont.familyName,
            fontFamily: artFont.familyName,
            hasBold: false,
            hasItalic: false
          }

          const fontItem = fontFamilyListCustom.find(`.item.${artFont.className}`)

          if (!fontItem.length) {
            toolboxOptionsInstance.artsFonts.push(artFont)
            addFontToMenu(artFont, fontFamilyListCustom, svgEditorInstance)
          }
        })
      }
    }

    function resetFontDropdown (toolboxOptionsInstance) {
      if ($('.font-family-dropdown input.search').val() === '' && ($('.fonts-menu-tab.customFonts').hasClass('selected') || $('.toolbox-menu-list.custom').hasClass('selected'))) {
        $('.toolbox-menu-list.custom').empty()

        addCustomFontsToList($('.toolbox-menu-list.custom'), toolboxOptionsInstance.svgEditorInstance, toolboxOptionsInstance)

        var buttonText = $translate.instant('showMore')
        const compiledHtml = $compile(`<uds-button class="fonts-toolbox-loadMore" fluid icon="refresh" size="small" text="${buttonText}" type="primary"/>`)($rootScope)
        $('.toolbox-menu-list.custom').append(compiledHtml)
        const element = $('.toolbox-menu-list.custom').find('.fonts-toolbox-loadMore')
        element.on('udsclick', toolboxOptionsInstance.loadMoreFonts)
        toolboxOptionsInstance._removeLoadMoreButton($('.font-family-dropdown'))
      }
    }
  }
})()
